import React from 'react';
import { Card, Badge, Btn, Divider, Stepper, Header, BottomNav, ExternalLinkIcon } from '../components/SharedComponents';
import C from '../styles/tokens';

const WithdrawalStatus = ({ navigate }) => (
  <div className="page-wrapper slide-up">
    <Header title="Withdrawal Status" onBack={() => navigate('withdraw')} />

    <div className="page-content-lg">

      {/* Order ID + Status */}
      <Card style={{ marginBottom: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div className="font-mono" style={{ fontSize: 11, color: C.textMuted }}>
            Withd ID: WD9821TRC20
          </div>
          <div style={{ fontWeight: 800, fontSize: 18, marginTop: 4, color: C.textPrimary }}>
            100 USDT
          </div>
        </div>
        <Badge color={C.warning}>Processing</Badge>
      </Card>

      {/* Stepper */}
      <Card style={{ marginBottom: 14 }}>
        <Stepper steps={[
          { label: 'Withdrawal Request Submitted',      status: 'done',   time: 'Today, 11:45 AM' },
          { label: 'Transaction Broadcasted to Blockchain', status: 'active', time: 'Today, 11:32 PM' },
          { label: 'Confirmed on Network',              status: 'pending', time: '8 / 12 Confirmations' },
        ]} />
      </Card>

      {/* TX Details */}
      <Card style={{ marginBottom: 16 }}>
        {[
          { label: 'Amount',                val: '100 USDT',                        valColor: C.accent },
          { label: 'Receiving Address',     val: 'TFh6UyVtrq935Bn9...kzOJNZBxAa',  mono: true },
          { label: 'TX Hash',               val: '0e6a7c...c9df3',                  mono: true },
          { label: 'Submitted',             val: 'Today, 11:45 AM' },
          { label: 'Network confirmations', val: '8 / 12' },
        ].map((row, i) => (
          <div key={i}>
            {i > 0 && <Divider />}
            <div className="flex justify-between items-center gap-10" style={{ padding: '9px 0' }}>
              <span style={{ fontSize: 13, color: C.textMuted, flexShrink: 0 }}>{row.label}</span>
              <span style={{
                fontWeight: 700, fontSize: 12,
                color: row.valColor || C.textPrimary,
                fontFamily: row.mono ? 'Space Mono, monospace' : 'Nunito, sans-serif',
                textAlign: 'right', wordBreak: 'break-all',
              }}>
                {row.val}
              </span>
            </div>
          </div>
        ))}
      </Card>

      {/* Blockchain Explorer Button */}
      <Btn
        onClick={() => {}}
        variant="primary" full size="lg"
        icon={<ExternalLinkIcon />}
      >
        View on Blockchain Explorer
      </Btn>

      <Btn
        onClick={() => navigate('dashboard')}
        variant="ghost" full size="md"
        style={{ marginTop: 10 }}
      >
        Back to Dashboard
      </Btn>
    </div>

    <BottomNav active="withdraw" navigate={navigate} />
  </div>
);

export default WithdrawalStatus;
